import { makeAxiosRequest } from 'utils/apiMethods';

export default {
  getPreSignedUrls: makeAxiosRequest('/get-s3-pre-signed-urls-for-company-uploads', {
    method: 'get',
  }),
};
